module.exports = __webpack_public_path__ + "img/thh-loser.8023f057.jpg";